<app-breadcrumb [title]="'Crear Extracto'" [items]="['Extractos']" [active_item]="'Crear Extracto'"></app-breadcrumb>
<div class="container-fluid">
<div class="col-sm-12 col-xl-12">
    <ngb-accordion [closeOthers]="false" [activeIds]="activePanel" #accordion="ngbAccordion">
        <ngb-panel id="static-1">
            <ng-template ngbPanelTitle>
                <i class="fa fa-car"></i>
                <span (click)="togglePanel('static-1')" class="ms-2"><strong>CONTRATISTA</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
                <form [formGroup]="formPlanilla">
                    <div class="card-body">
                        <div class="card card-absolute rounded">
                            <div class="card-header bg-primary">
                                <h5 class="text-white"><strong>DATOS DEL CONTRATANTE</strong>
                                </h5>

                            </div>
                            <div class="card-body">
                                <div class="row align-items-end mt-3 gy-3">
                                    <!-- Contratante -->
                                    <div class="col-12 col-md-7">
                                        <label class="form-label"><strong>CONTRATANTE</strong> *:</label>
                                        <div class="input-group">
                                            <div class="form-control p-0 border-0">
                                                <ng-select #inputEmpresa [items]="empresas" bindValue="nit"
                                                    placeholder="Selecciona una opción"
                                                    [(ngModel)]="empresaSeleccionada" [searchFn]="customSearchFn"
                                                    class="w-100" formControlName="empresa"
                                                    (change)="cargaContratista()"
                                                    [loading]="loadingContratista"
                                                    [attr.title]="empresaSeleccionada?.nombre">

                                                    <ng-template ng-label-tmp let-item="item">
                                                        {{ item.nit }} - {{ item.nombre }}
                                                    </ng-template>

                                                    <ng-template ng-option-tmp let-item="item">
                                                        {{ item.nit }} - {{ item.nombre }}
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                            <button type="button" class="btn btn-primary btn-sm"
                                                (click)="openModalEmpresa(myModal)"
                                                ngbTooltip="Crear empresa contratista">
                                                <i class="icofont icofont-plus"></i>
                                            </button>
                                        </div>
                                        <!-- Indicador de carga -->
                                        <div *ngIf="loadingContratista" class="mt-2 p-2 bg-light border border-primary rounded">
                                            <div class="d-flex align-items-center">
                                                <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
                                                    <span class="visually-hidden">Cargando...</span>
                                                </div>
                                                <small class="text-primary fw-semibold">
                                                    <i class="icofont icofont-refresh me-1"></i>
                                                    Cargando datos de contratatos...
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Botones de acción -->
                                    <div class="col-12 col-md-5 d-flex flex-column flex-md-row gap-2">
                                        <button class="btn btn-info w-100 w-md-50" type="button"
                                            [disabled]="!empresaSeleccionada" (click)="openModalContrato(modalContratos)">
                                            <i class="icofont icofont-plus"></i> NUEVO CONTRATO
                                        </button>
                                        <button class="btn btn-primary w-100 w-md-50" type="button"
                                            (click)="ListadoContratos()" *ngIf="!esUsuarioTenant">
                                            <i class="icofont icofont-list"></i> LISTADO DE CONTRATOS
                                        </button>
                                       
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="card card-absolute rounded" style="margin-top: 50px;" *ngIf="isContratos">
                            <div class="card-header bg-primary">
                                <h5 class="text-white"><strong>CONTRATOS ASOCIADOS</strong></h5>
                            </div>
                            <div class="card-body">
                                <div class="">
                                    <table class="table table-light custom-datatable table-bordered table-responsive mt-3">

                                        <thead class="">
                                            <tr>
                                                <th class="text-center" style="width: 20%;"><strong>NÚMERO DE DOCUMENTO</strong></th><td class="text-center">{{ empresa?.nit || 'N/A' }}</td>
                                               
                                            </tr>
                                            <tr>
                                                 <th class="text-center"><strong>NOMBRE CONTRATISTA</strong></th><td class="text-center">{{ empresa?.nombre || 'N/A' }}</td>
                                                
                                            </tr>
                                            <tr>
                                                <th class="text-center"><strong>NÚMERO DE CONTRATOS</strong></th>
                                                <td>
                                                    <ng-select [items]="numeroContratos" bindLabel="numero"
                                                        bindValue="numero" placeholder="Selecciona un contrato"
                                                        formControlName="contrato"
                                                        (change)="cargarDatosContrato($event)">
                                                        <ng-template ng-option-tmp let-item="item">
                                                            {{ item.numero }} -  ({{ item.fin | date: 'dd/MM/yyyy' }})
                                                        </ng-template>
                                                        <ng-template ng-label-tmp let-item="item">
                                                            {{ item.numero }} - ({{ item.fin | date: 'dd/MM/yyyy' }})
                                                        </ng-template>
                                                    </ng-select>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                
                                                
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>  


                            </div>

                        </div>

                        <div class="card card-absolute rounded" style="margin-top: 50px;" *ngIf="isResponsable">
                            <div class="card-header bg-primary text-white">
                                <h5 class="text-white"><strong>RESPONSABLE DEL CONTRATO</strong></h5>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-bordered mt-3">
                                        <thead class="bg-soft-purple">
                                            <tr>
                                                <th class="text-center"><strong>DOCUMENTO DEL RESPONSABLE</strong></th>
                                                <th class="text-center"><strong>NOMBRE RESPONSABLE</strong></th>
                                                <th class="text-center"><strong>DIRECCIÓN</strong></th>
                                                <th class="text-center"><strong>TELÉFONO</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-center">{{ datosResp?.idres || 'N/A' }}</td>
                                                <td class="text-center">{{ datosResp?.responsable || 'N/A' }}</td>
                                                <td class="text-center">{{ datosResp?.dirresponsble || 'N/A' }}</td>
                                                <td class="text-center">{{ datosResp?.telres || 'N/A' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>


                            </div>

                        </div>
                    </div>
                </form>





            </ng-template>
        </ngb-panel>

        <ngb-panel id="static-2">
            <ng-template ngbPanelTitle>
                <i class="icofont icofont-id-card"></i>
                <span class="ms-2"><strong>DATOS DEL SERVICIO</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>

                <form [formGroup]="formPlanilla">
                    <div class="card-body">
                        <div class="card card-absolute rounded">
                            <div class="card-header bg-primary">
                                <h5 class="text-white"><strong>FECHAS DEL CONTRATO</strong>
                                </h5>

                            </div>
                       
<div class="card-body">
  <div class="row g-3 align-items-end my-2">

    <!-- FECHA DE SALIDA -->
    <div class="col-12 col-md-4">
      <label class="form-label fw-bold" for="finicial">
       
        FECHA DE SALIDA <span class="text-danger">*</span>
      </label>

      <input
        #inputInicial
        id="finicial"
        type="date"
        class="form-control"
        [min]="fechaMinimaSalida"
        [max]="formatDateForInput(fechaMaximaSalida)"
        formControlName="finicial"
        (paste)="preventInput($event)"
        (keydown)="preventInput($event)" />
    </div>

    <!-- FECHA DE REGRESO -->
    <div class="col-12 col-md-4">
      <label class="form-label fw-bold" for="ffinal">
       
        FECHA DE REGRESO <span class="text-danger">*</span>
      </label>

      <input
        id="ffinal"
        type="date"
        class="form-control"
        formControlName="ffinal"
        [min]="fechaHoy"
        [max]="formatDateForInput(fechaMaximaSalida)"
        (paste)="preventInput($event)"
        (keydown)="preventInput($event)" />

      <div
        *ngIf="formPlanilla.errors?.fechaInvalida &&
               formPlanilla.get('ffinal')?.touched"
        class="text-danger mt-1 small">
        <i class="icofont icofont-warning me-1"></i>
        La fecha de regreso debe ser posterior a la fecha de salida.
      </div>
    </div>

   

  </div>
</div>


<div class="fecha-limite-card" >
  <div class="fecha-limite-icon">
    <i class="icofont icofont-calendar"></i>
  </div>

  <div class="fecha-limite-info">
    <div class="fecha-limite-titulo">
      FECHA MÁXIMA PARA ELABORAR EL EXTRACTO
    </div>

    <div class="fecha-limite-descripcion">
      Debes elaborar el extracto a más tardar el:
    </div>
  </div>

  <div class="fecha-limite-valor">
    <i class="icofont icofont-clock-time"></i>
    <span>{{ fechaMaximaSalida | date:'dd/MM/yyyy' }}</span>
  </div>
</div>

                        </div>

                        <div class="card card-absolute rounded" style="margin-top: 50px;">
                            <div class="card-header bg-primary">
                                <h5 class="text-white"><strong>INFORMACIÓN DEL CONTRATO</strong></h5>
                            </div>
                            <div class="card-body">
                                <div class="row g-3 my-2">
                                    <div class="col-md-4">
                                        <label class="form-label" for="objeto"><strong>OBJETO DEL CONTRATO *:</strong></label>
                                        <ng-select id="objeto" [items]="objetos" bindLabel="descripcion" bindValue="id"
                                            placeholder="Selecciona una opción" formControlName="objeto"
                                            (change)="onObjetoChange($event)" [disabled]="objetoDeshabilitado">
                                        </ng-select>
                                    </div>

                                    <div class="col-md-4">
                                        <label class="form-label" for="viaje"><strong>TIPO DE VIAJE *:</strong></label>
                                        <ng-select id="viaje" [items]="tipoviaje" bindLabel="descripcion" bindValue="id"
                                            placeholder="Selecciona una opción" formControlName="viaje">
                                        </ng-select>
                                    </div>

                                    <div class="col-12">
                                        <label class="form-label" for="complemento"><strong>COMPLEMENTO AL OBJETO DE CONTRATO                                             :</strong></label>
                                        <textarea class="form-control" id="complemento" rows="2"
                                            formControlName="complemento"></textarea>
                                    </div>
                                    <!-- Disponibilidad -->
                                    <div class="col-12" *ngIf="isDisponilidad">
                                        <label class="form-label"><strong>DISPONIBILIDAD TOTAL:</strong></label>
                                        <textarea class="form-control" rows="2"
                                            formControlName="disponibilidad"></textarea>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="card card-absolute rounded" style="margin-top: 50px;">
                            <div class="card-header bg-primary text-white">
                                <h5 class="text-white"><strong>RUTA A REALIZAR</strong></h5>
                            </div>
                            <div class="card-body">
                                <div class="row g-3 align-items-end my-2">
                                    <!-- Rutas (con botón al lado) -->
                                    <div class="col-md-12">
                                        <label class="form-label"><strong>RUTAS *:</strong></label>
                                        <div class="input-group">
                                            <div class="form-control p-0 border-0">
                                                <ng-select class="flex-grow-1" [items]="Rutas" bindLabel="nombre"
                                                    bindValue="nombre" placeholder="Selecciona una opción"
                                                    formControlName="ruta" (change)="onRutaChange($event)">
                                                </ng-select>
                                            </div>
                                            <button type="button" class="btn btn-primary btn-sm"
                                                (click)="openModal(myModal3)" ngbTooltip="Crear Ruta">
                                                <i class="icofont icofont-plus"></i>
                                            </button>
                                            
                                        </div>
                                    </div>


                                    <!-- Origen -->
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>ORIGEN *:</strong></label>
                                        <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO"
                                            placeholder="Selecciona una opción" formControlName="origen">
                                        </ng-select>
                                    </div>

                                    <!-- Destino -->
                                    <div class="col-md-6">
                                        <label class="form-label"><strong>DESTINO *:</strong></label>
                                        <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO"
                                            placeholder="Selecciona una opción" formControlName="destino">
                                        </ng-select>
                                    </div>


                                </div>
                            <div class="col-12 col-md-3 mt-4">
                                <div class="gestion-pasajeros-box">
                                    

                                    <small class="text-dark d-block mt-2">
                                        Registra y consulta los pasajeros del extracto.
                                    </small>
                                </div>
                            </div>
                           
                            <div class="col-12 mt-3">
                                <div class="resumen-pasajeros">

                                    <div class="resumen-pasajeros-contenido">
                                        <div class="resumen-pasajeros-icono">
                                            <i class="fa fa-users"></i>
                                        </div>

                                        <div class="resumen-pasajeros-info">
                                            <span class="resumen-pasajeros-total">
                                                {{ pasajeros?.length || 0 }}
                                            </span>

                                            <span class="resumen-pasajeros-texto">
                                                {{ pasajeros?.length === 1
                                                ? 'Pasajero registrado'
                                                : 'Pasajeros registrados' }}
                                            </span>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn btn-secondary" (click)="gestionarPasajeros(1)">
                                        <i class="fa fa-user-plus me-2"></i>
                                        Gestionar pasajeros
                                    </button>

                                </div>
                            </div>

                            </div>

                        </div>
                         <!-- GESTIÓN DE PASAJEROS -->
  
                    </div>
                </form>

            </ng-template>
        </ngb-panel>

        <ngb-panel id="static-3">
            <ng-template ngbPanelTitle>
                <i class="icofont icofont-id-card"></i>
                <span class="ms-2"><strong>DATOS DEL VEHÍCULO Y CONDUCTORES</strong></span>

            </ng-template>

            <ng-template ngbPanelContent>
                <div class="card-body">
                    <div class="card card-absolute rounded">
                        <div class="card-header bg-primary">
                            <h5 class="text-white"><strong>INFORMACIÓN DEL VEHÍCULO</strong>
                            </h5>

                        </div>

<div class="card-body">

    <!-- ENCABEZADO DEL VEHÍCULO -->
    <div class="vehiculo-header mt-2 mb-3">
        <div class="vehiculo-icono">
            <i class="icofont icofont-car-alt-3"></i>
        </div>

        <div class="flex-grow-1">
            <span class="vehiculo-label">VEHÍCULO SELECCIONADO</span>
            <h5 class="vehiculo-placa mb-1">
                {{ placa || 'SIN PLACA' }}
            </h5>
            <span class="vehiculo-subtitulo">
                {{ marca || 'Marca no registrada' }}
                <span *ngIf="modelo"> · Modelo {{ modelo }}</span>
            </span>
        </div>

        <span class="badge bg-primary vehiculo-badge">
            {{ tipos || 'SIN CLASE' }}
        </span>
    </div>

    <!-- INFORMACIÓN DEL VEHÍCULO -->
    <div class="vehiculo-grid">

        <!-- MARCA -->
        <div class="vehiculo-dato">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-car"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">MARCA</span>
                <span class="vehiculo-dato-valor">
                    {{ marca || 'Sin información' }}
                </span>
            </div>
        </div>

        <!-- MODELO -->
        <div class="vehiculo-dato">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-calendar"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">MODELO</span>
                <span class="vehiculo-dato-valor">
                    {{ modelo || 'Sin información' }}
                </span>
            </div>
        </div>

        <!-- CLASE -->
        <div class="vehiculo-dato">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-list"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">CLASE DE VEHÍCULO</span>
                <span class="vehiculo-dato-valor">
                    {{ tipos || 'Sin información' }}
                </span>
            </div>
        </div>

        <!-- NÚMERO INTERNO -->
        <div class="vehiculo-dato">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-id-card"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">NÚMERO INTERNO</span>
                <span class="vehiculo-dato-valor">
                    {{ interno || 'Sin información' }}
                </span>
            </div>
        </div>

        <!-- TARJETA DE OPERACIÓN -->
        <div class="vehiculo-dato vehiculo-dato-ancho">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-file-document"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">
                    NÚMERO DE TARJETA DE OPERACIÓN
                </span>
                <span class="vehiculo-dato-valor">
                    {{ numero_tarjeta || 'Sin información' }}
                </span>
            </div>
        </div>

        <!-- RELACIÓN -->
        <div class="vehiculo-dato">
            <div class="vehiculo-dato-icono">
                <i class="icofont icofont-link"></i>
            </div>
            <div class="vehiculo-dato-contenido">
                <span class="vehiculo-dato-label">RELACIÓN</span>
                <span class="vehiculo-dato-valor">
                    {{ opcionSeleccionada || 'Sin información' }}
                </span>
            </div>
        </div>

    </div>
</div>

                    </div>

                <div class="card card-absolute rounded my-4" style="margin-top: 50px;">
                    <div class="card-header bg-primary">
                        <h5 class="text-white m-0"><strong>CONDUCTORES ASIGNADOS</strong></h5>
                    </div>
                
                    <div class="card-body p-3">
                
                         <div class="card-body p-3">

   
<form class="mega-inline">
  <div class="conductores-grid">

    <div
      class="conductor-card"
      *ngFor="
        let conductor of conductores
          | paginate: {
              itemsPerPage: pageSize1,
              currentPage: page1
            };
        let i = index
      "
      [class.conductor-seleccionado]="conductor.seleccionado">

      <!-- CABECERA -->
      <div class="conductor-card-header">

        <div class="form-check checkbox checkbox-primary conductor-checkbox">
          <input
            class="form-check-input"
            type="checkbox"
            [id]="'conductor-' + i"
            [checked]="conductor.seleccionado"
            (change)="toggleSeleccion(conductor, $event)" />

          <label
            class="form-check-label"
            [for]="'conductor-' + i">
          </label>
        </div>

        <div class="conductor-avatar">
          <i class="icofont icofont-user-alt-3"></i>
        </div>

        <div class="conductor-identidad">
          <span class="conductor-label">CONDUCTOR</span>
          <h6 class="conductor-nombre mb-0">
                {{
                (
                (conductor.propietario?.primernombre || '') + ' ' +
                (conductor.propietario?.segundonombre || '') + ' ' +
                (conductor.propietario?.papellidos || '') + ' ' +
                (conductor.propietario?.seapellidos || '')
                ).trim() | uppercase
                }}
          </h6>
        </div>

        <span
          *ngIf="conductor.seleccionado"
          class="badge bg-primary conductor-badge">
          Seleccionado
        </span>
      </div>

      <!-- DATOS -->
      <div class="conductor-card-body">

        <div class="conductor-info">
          <i class="icofont icofont-id-card"></i>
          <div>
            <span class="conductor-info-label">CÉDULA</span>
            <span class="conductor-info-value">
              {{ conductor.conductor_id || 'No registrada' }}
            </span>
          </div>
        </div>

        <div class="conductor-info">
          <i class="icofont icofont-card"></i>
          <div>
            <span class="conductor-info-label">
              LICENCIA DE CONDUCCIÓN
            </span>
            <span class="conductor-info-value">
              {{ conductor.propietario?.numerolic || 'No registrada' }}
            </span>
          </div>
        </div>

        <div class="conductor-vencimientos">

          <div class="vencimiento-item">
            <div class="vencimiento-titulo">
              <i class="icofont icofont-calendar"></i>
              <span>Vencimiento licencia</span>
            </div>

            <span
              class="badge vencimiento-badge"
              [ngClass]="getEstadoColor(
                getEstadoLicencia(conductor.propietario?.vencelic)
              )">
              {{
                conductor.propietario?.vencelic
                  ? (conductor.propietario?.vencelic | date:'dd/MM/yyyy')
                  : 'Sin fecha'
              }}
            </span>
          </div>

          <div class="vencimiento-item">
            <div class="vencimiento-titulo">
              <i class="icofont icofont-shield-alt"></i>
              <span>Vencimiento ARL</span>
            </div>

            <span
              class="badge vencimiento-badge"
              [ngClass]="getEstadoColor(
                getEstadoLicencia(conductor.propietario?.fechacobeps)
              )">
              {{
                conductor.propietario?.fechacobeps
                  ? (conductor.propietario?.fechacobeps | date:'dd/MM/yyyy')
                  : 'Sin fecha'
              }}
            </span>
          </div>

        </div>
      </div>
    </div>

  </div>
</form>


    <!-- SIN CONDUCTORES -->
    <div
      *ngIf="!conductores || conductores.length === 0"
      class="conductores-vacio">

      <i class="icofont icofont-users-alt-5"></i>

      <h6>No hay conductores disponibles</h6>

      <p class="mb-0">
        No se encontraron conductores para asignar.
      </p>
    </div>

   

  </div>
                
                
                        <!-- Paginación -->
                        <pagination-controls (pageChange)="page1 = $event"
                            class="mt-3 d-flex justify-content-center"></pagination-controls>
                
                    </div>
                </div>

                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>

    <div class="btn-showcase my-4">
        <button type="button" class="btn btn-primary" (click)="guardarPlanilla()" >GUARDAR EXTRACTO</button>
    </div>
</div>

<ng-template #myModal let-modal>
    <div class="card border-4 rounded-3">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
            <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
        </div>
        <div class="modal-body">
            <form [formGroup]="formEmpresa">
                <!-- Inputs antes de la tabla -->
                <div class="row g-3">
                    <div class="col-md-3">
                        <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
                        <input #inputNit class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT"
                            required formControlName="nit"
                            [class.is-invalid]="formEmpresa.get('nit')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa un nombre.
                        </div>

                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="digito">
                           <strong>Digito de Verificacción *:</strong></label>
                        <input #inputCodigo class="form-control" id="digito" type="number" required
                            placeholder="Ingrese el dígito de verificación" formControlName="digito"
                            [class.is-invalid]="formEmpresa.get('digito')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('digito')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa un digito de verificación.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
                        <input #inputNombre class="form-control" id="nombre" type="text"
                            placeholder="Ingrese el nombre o razon social" required formControlName="nombre"
                            [class.is-invalid]="formEmpresa.get('nombre')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa un número de documento.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="direccion">
                            <strong>Dirección *:</strong></label>
                        <input #inputDireccion class="form-control" id="direccion" type="text" required
                            placeholder="Ingresa una dirección" formControlName="direccion"
                            [class.is-invalid]="formEmpresa.get('direccion')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('direccion')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa una dirección.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label"><strong>Ciudad *:</strong></label>
                        <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                            placeholder="Selecciona una opción" formControlName="ciudad">
                        </ng-select>
                        <div *ngIf="formEmpresa.get('ciudad')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa una ciudad.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="telefono"><strong>Teléfono fijo:</strong></label>
                        <input class="form-control" id="telefono" type="number" inputmode="numeric"
                            placeholder="Ingresa el teléfono fijo" formControlName="telefono" maxlength="10"
                            pattern="[0-9]*" />
                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="celular"><strong>Teléfono celular *:</strong></label>
                        <input #inputCelular class="form-control" id="celular" type="number" inputmode="numeric"
                            placeholder="Ingresa el teléfono celular" formControlName="celular" required maxlength="10"
                            pattern="[0-9]*" [class.is-invalid]="formEmpresa.get('celular')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('celular')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa un número de celular.
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label class="form-label" for="email">
                            <strong>Correo Electrónico :</strong></label>
                        <input #inputEmail class="form-control" id="email" type="text" 
                            placeholder="Ingresa un correo valido" formControlName="email"
                            [class.is-invalid]="formEmpresa.get('email')?.invalid && validate" />
                        <div *ngIf="formEmpresa.get('email')?.invalid && validate" class="invalid-feedback">
                            Por favor, ingresa un correo electronico.
                        </div>
                    </div>

                    <div class="row g-3 mb-3">
                        <div class="mb-3">
                            <label><strong>Observaciones:</strong></label>
                            <textarea class="form-control" id="observaciones" rows="3"
                                formControlName="observaciones"></textarea>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
                Guardar
            </button>
            <button class="btn btn-secondary" (click)="modal.dismiss()">
                Cancelar
            </button>
        </div>
    </div>
</ng-template>

<ng-template #modalContratos let-modal>
  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ editMode ? 'EDITAR CONTRATO - ID: ' + formContrato.get('id')?.value : 'CREAR CONTRATO' }}
    </h5>
    <button class="btn-close" type="button" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <form class="form-bookmark needs-validation" novalidate>
      <!-- Placeholder row for validación o notificaciones futuras -->
      <div class="row"></div>
    </form>

    <!-- Acordeón de secciones -->
    <div class="card">
      <div class="col-12">
        <ngb-accordion [closeOthers]="true" [activeIds]="activePanelmodel" #accordion="ngbAccordion">

          <!-- Panel: Datos del Contratante -->
          <ngb-panel id="static-1">
            <ng-template ngbPanelTitle>
              <i class="fa fa-car"></i>
              <span class="ms-2" (click)="togglePanel('static-1')"><strong>DATOS DEL CONTRATANTE</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <!-- Empresa seleccionada -->
                <div class="col-md-5 mb-3">
                  <label class="form-label"><strong>Contratante *:</strong></label>
                  <div class="input-group">
                    <ng-select #inputEmpresa
                      [items]="empresas"
                      bindLabel="nombre"
                      bindValue="nit"
                      placeholder="Selecciona una opción"
                      [(ngModel)]="empresaSeleccionada"
                      (change)="mostrarEmpresaSeleccionada()"
                      class="form-control p-0 border-0"
                      [attr.title]="empresaSeleccionada?.nombre">
                    </ng-select>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)" ngbTooltip="Crear empresa contratista">
                      <i class="icofont icofont-plus"></i>
                    </button>
                  </div>
                </div>

                <!-- Formulario datos contratante -->
                <form [formGroup]="formContrato">
                  <div class="row g-3 my-4">
                    <div class="col-md-6">
                      <label class="form-label"><strong>CC / NIT *:</strong></label>
                      <input class="form-control" type="number" placeholder="Ingrese CC o NIT" formControlName="cedula" readonly />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Contratista *:</strong></label>
                      <input class="form-control" type="text" placeholder="Nombre del contratista" formControlName="contratante" readonly />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Dirección *:</strong></label>
                      <input class="form-control" type="text" placeholder="Dirección" formControlName="direccion" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Ciudad *:</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO" placeholder="Ciudad" formControlName="ciudad"></ng-select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Teléfono *:</strong></label>
                      <input class="form-control" type="number" placeholder="Teléfono" formControlName="telefono" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Correo Electrónico:</strong></label>
                      <input class="form-control" type="text" placeholder="Correo Electrónico" formControlName="mail" />
                    </div>
                  </div>
                </form>

                <!-- Botón para trasladar datos -->
                <div class="btn-showcase my-4">
                  <button class="btn btn-outline-primary" (click)="trasladarDatosEmpresa()">
                    Trasladar Datos a Responsable
                  </button>
                </div>
              </div>
            </ng-template>
          </ngb-panel>

          <!-- Panel: Datos del Responsable -->
          <ngb-panel id="static-2">
            <ng-template ngbPanelTitle>
              <i class="icofont icofont-id-card"></i>
              <span class="ms-2"><strong>DATOS DEL RESPONSABLE</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <form [formGroup]="formContrato">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label"><strong>CC / NIT *:</strong></label>
                      <input class="form-control" type="number" formControlName="idres" placeholder="Ingrese CC o NIT" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Responsable *:</strong></label>
                      <input class="form-control" type="text" formControlName="responsable" placeholder="Nombre o razón social" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Dirección *:</strong></label>
                      <input class="form-control" type="text" formControlName="dirresponsble" placeholder="Dirección" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Ciudad *:</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO" formControlName="cuires" placeholder="Ciudad"></ng-select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Teléfono *:</strong></label>
                      <input class="form-control" type="number" formControlName="telres" placeholder="Teléfono fijo" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Correo Electrónico:</strong></label>
                      <input class="form-control" type="text" formControlName="mailresp" placeholder="Correo electrónico" />
                    </div>
                  </div>
                </form>
              </div>
            </ng-template>
          </ngb-panel>

          <!-- Panel: Datos del Contrato -->
          <ngb-panel id="static-3">
            <ng-template ngbPanelTitle>
              <i class="icofont icofont-id-card"></i>
              <span class="ms-2"><strong>DATOS DEL CONTRATO</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <form [formGroup]="formContrato">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label"><strong>Objeto del contrato *:</strong></label>
                      <ng-select [items]="objetos" bindLabel="descripcion" bindValue="id" formControlName="tipo" placeholder="Objeto del contrato"></ng-select>
                    </div>
                    <div class="col-md-6">
                  <label class="form-label"><strong>Disponibilidad Total *</strong></label>
                  <ng-select 
                    [items]="[{ label: 'Sí', value: 1 }, { label: 'No', value: 0 }]"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="disponibilidad"
                                        (change)="onDisponibilidadChange($event?.value ?? $event)"
                    placeholder="Seleccione una opción">
                  </ng-select>
                </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Fecha inicial *:</strong></label>
                      <input type="date" class="form-control" formControlName="inicio" [min]="minDate" (paste)="preventInput($event)"
                                            (keydown)="preventInput($event)"/>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Fecha final *:</strong></label>
                      <input type="date" class="form-control" formControlName="fin" [min]="fechaMinimaFinal" (paste)="preventInput($event)"
                                            (keydown)="preventInput($event)" />
                    </div>
                  <div>
                    <div class="row" *ngIf="mostrarOrigenDestino">
                   <div class="col-md-6">
                      <label class="form-label"><strong>Origen *</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una opción"
                        formControlName="origen">
                      </ng-select>
                    </div>
                    
                    <div class="col-md-6">
                      <label class="form-label"><strong>Destino *</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una opción"
                        formControlName="destino">
                      </ng-select>
                    </div>
                    
                    </div>
                  
                    </div>                   <div class="col-md-6">
                      <label class="form-label"><strong>Pasajeros:</strong></label>
                      <input class="form-control" type="number" formControlName="pasajeros" placeholder="Cantidad de pasajeros" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Valor del servicio:</strong></label>
                      <input class="form-control" type="number" formControlName="valor" placeholder="Valor" />
                    </div>
                   
                                  </div>
                </form>
              </div>
            </ng-template>
          </ngb-panel>

        </ngb-accordion>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarContrato(modalContratoRef)">
        {{ editMode ? 'Actualizar' : 'Crear' }} Contrato
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    </div>
  </div>
</ng-template>
<ng-template #myModal3 let-modal>
    <div class="card border-4 rounded-3">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
            <h5 class="mb-0">
               <strong>CREACION DE RUTA</strong>
            </h5>
        </div>
        <div class="card-body">
            <form [formGroup]="rutaForm">
                <div class="row g-3">
                    <div class="col-md-3 mb-3">
                        <label class="form-label"><strong>Origen</strong></label>
                        <ng-select #inputOrigen [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                            placeholder="Seleccione el origen" [(ngModel)]="origenSeleccionado"
                            (change)="actualizarNombreRuta()" formControlName="origen">
                        </ng-select>
                    </div>

                    <div class="col-md-3 mb-3">
                        <label class="form-label"><strong>Destino</strong></label>
                        <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                            placeholder="Seleccione el destino" [(ngModel)]="destinoSeleccionado"
                            (change)="actualizarNombreRuta()" formControlName="destino">
                        </ng-select>
                    </div>

                    <div class="col-md-3 mb-3">
                        <label class="form-label"><strong>Nombre de la ruta</strong></label>
                        <input class="form-control" type="text" placeholder="Ingrese el nombre de la ruta"
                            [value]="nombreRuta" formControlName="nombre" />
                    </div>

                    <div class="col-md-3 mb-3">
                        <label class="form-label"><strong>Descripción</strong></label>
                        <input class="form-control" type="text" placeholder="Ingrese descripción"
                            formControlName="ruta" />
                    </div>
                </div>


                <div class="modal-footer">
                    <button class="btn btn-primary" (click)="guardarRuta()">
                        "Guardar"
                    </button>
                    <button class="btn btn-secondary" (click)="modal.dismiss()">
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>